import { generateCSPHeaderValue } from "@snapchat/web-headers";
import { POLICY_DIRECTIVES } from "../constants/csp";
import { setRequestIDIfPresent } from "./requests";
export function setResponseHeaders(requestID, req, res) {
    if (res) {
        setSecurityHeaders(res);
        setRequestIDIfPresent(requestID, res);
        setCacheHeaders(res);
    }
}
const maxAgeMins = 5;
const maxAgeSecs = maxAgeMins * 60;
const cacheControl = `public,max-age=${maxAgeSecs}`;
function setCacheHeaders(res) {
    // next.js generates the ETag header for us:
    //  https://nextjs.org/docs/api-reference/next.config.js/disabling-etag-generation
    res.setHeader("Cache-Control", cacheControl);
}
// TODO: consider https://github.com/jagaapple/next-secure-headers
function setSecurityHeaders(res) {
    res.setHeader("X-Frame-Options", "DENY");
    res.setHeader("X-XSS-Protection", "0");
    res.setHeader("Content-Security-Policy", generateCSPHeaderValue(POLICY_DIRECTIVES));
    res.setHeader("Strict-Transport-Security", "max-age=31536000"); // 1 year in seconds
}
